import { render, staticRenderFns } from "./MakeTurn.vue?vue&type=template&id=22322583&scoped=true"
import script from "./MakeTurn.vue?vue&type=script&lang=js"
export * from "./MakeTurn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22322583",
  null
  
)

export default component.exports